import { MapBounds, MapClipRegion, MapFilterOption, MapTool } from './map.models';

export class SetClipRegion {
  static readonly type = '[Map] SetClipRegion';
  constructor(public clipRegion: MapClipRegion) {}
}

export class ClearClipRegion {
  static readonly type = '[Map] ClearClipRegion';
}

export class SetMapFilterOption {
  static readonly type = '[Map] SetMapFilterOption';
  constructor(public filterOption: MapFilterOption) {}
}

export class SetActiveMapTool {
  static readonly type = '[Map] SetActiveMapTool';
  constructor(public mapTool: MapTool) {}
}

export class SetBounds {
  static readonly type = '[FeatureLayer] SetBounds';
  constructor(public bounds: MapBounds) {}
}
